<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Greg McEnnally was trained as a Maths and Science teacher, working in Australia and Papua New Guinea. In order to fill the need for English teachers he completed his TESOL (Teaching English to Speakers of Other Languages) and taught in Indonesia. From here he went to China in 2002 to teach English initially in Fuzhou, Fujian Province, then later in Tongren, Guizhou Province and Chongqing. This book is concerned with the 4 ½ years he spent teaching in Fuzhou. This is not a travel book, but an account of life in this city during that time – the people, lifestyle, culture and some ideas on education.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1e7c1db6